import React,{useEffect} from "react";
import Helper from '../functions/Helper.js';
import LikeButton from "./LikeButton.js"


const StoreOutput=({style})=>{

  if(style.colorways?.length>0){
    var firstColorway=style.colorways[0];
    var discount=Math.round((1-(firstColorway.price_discount/firstColorway.list_price))*100);
    return(
      <React.Fragment>
        <div style={{  fontSize:14,lineHeight:1.3,marginTop:3,color:"#767676"}}>
          {style.colorways.length>1 ? "in " + (style.colorways?.length + style.resells?.length) + " shops" : "from " + firstColorway.shop_name}
        </div>
        <div style={{marginTop:2,lineHeight:1.3,display:"flex",flexDirection:"row"}}>
          <div style={{color:discount>1 ? "#e32b2b" :"black",fontWeight:discount>1 ? 500 : 400}}>
            ${firstColorway.price_discount}
          </div>
          {discount> 1 &&
          <div style={{color:"#767676",textDecorationLine:"line-through",display:"flex",justifyContent:"center",alignItems:"center",textDecorationStyle: 'solid',marginLeft:5,fontSize:14}}>
            ${Math.round(Number(firstColorway.list_price))}
          </div>}
        </div>
      </React.Fragment>
    );

  }
  else if (style.resells?.length>0){
    var firstResell=style.resells[0];
    return(
      <React.Fragment>
        <div style={{  fontSize:14,lineHeight:1.3,marginTop:3,color:"#767676"}}>
          {style.resells.length>1 ? "from " + style.resells.length + " Resellers" : "from " + firstResell.shop_name}
        </div>
        <div style={{marginTop:2,lineHeight:1.3,display:"flex",flexDirection:"row"}}>
          <div style={{color:"black",fontWeight:400}}>
            ${firstResell.price_discount}
          </div>
        </div>
      </React.Fragment>
    );
  }
  else{
    return(
      <React.Fragment>
        <div style={{marginTop:2}}>
          <div style={{fontSize:14,color:"#767676"}}>No stores found</div>
        </div>
      </React.Fragment>
    );
  }


};



export default function SliderItem(props){
  let swiperWidth=props.swiperWidth || 200;
  let style=props.styleItem;
  let imageHeight= props.imageHeight ? props.imageHeight : 0.85*swiperWidth;


  useEffect(()=>{
    if(props.fetchData){
      props.fetchData()
    }
  },[])

  return(
    <div  style={{position:"relative",boxSizing:"border-box",cursor:"pointer",width: props.responsive ? "100%" : swiperWidth}} onClick={()=>{if(!props.preview){props.onClick()}}}>
      { props.showLikeButton && !props.preview &&
        <div style={{position:"absolute",top:0, right:0,zIndex:1}}>
          <LikeButton showCounter={props.showCounter} likeCounter={style.likes} style_id={style.style_id} shoe_id={style.shoe_id}/>
        </div>
      }
      <div style={props.responsive ? {backgroundColor:"#f8f8f8",paddingTop:"100%",position:"relative"} : {backgroundColor:"#f8f8f8",height:imageHeight,}} >
        {!props.preview &&
          <picture>
            <source
              type="image/webp"
              data-srcset={Helper.create_source_set({master:style.picture_url,thumbnails:"1"},undefined,"webp")}
              sizes={props.sizes ?? swiperWidth+"px"}
              />
            <source
              type="image/png"
              data-srcset={Helper.create_source_set({master:style.picture_url,thumbnails:"1"},undefined,"png")}
              sizes={props.sizes ?? swiperWidth+"px"}
              />
            <img title={"SKU: " + style.sku}
              className="lazyload"
              style={
                props.responsive ? {
                  position:"absolute",
                  bottom:0,
                  padding:10,
                  transform:style.mirror==="1" ?  "scaleX(-1)" :"",
                  ...props.imageProps
                 }
                :
                {padding:"10px",
                  height:imageHeight,
                  objectFit:"contain",
                  objectPosition:"bottom",
                  transform:style.mirror==="1" && "scaleX(-1)"
                  ,...props.imageProps}
                }
                alt={style.name}
                width={style.width}
                height={style.height}
                sizes={props.sizes ?? swiperWidth+"px"}
                data-srcset={Helper.create_source_set({master:style.picture_url,thumbnails:"1"})}/>
            </picture>

        }
      </div>

      <div style={{flex:1,paddingTop:2,...props.textContainerStyle}}>
        {!props.preview &&
          <React.Fragment>
            {props.showShoeName &&
              <div style={{
                  fontSize:16,
                  lineHeight:1.3,
                  fontWeight:700,
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  display: "-webkit-box",
                  "WebkitBoxOrient":"vertical",
                  "WebkitLineClamp": "2",
                  marginTop:3}}>
                {props.shoeName}
              </div>
            }
            {props.showStyleName &&
              <div style={{
                  fontSize:14,
                  lineHeight:1.3,
                  fontWeight:props.showShoeName ? "400" : "600",
                  overflow:"hidden",
                  textOverflow:"ellipsis",
                  display: "-webkit-box",
                  "WebkitBoxOrient":"vertical",
                  "WebkitLineClamp": props.showShoeName ? "1" : "2",
                  marginTop:3}}>
                  {style.name}
              </div>
            }
            {props.showPrice &&
              <StoreOutput style={style}/>
            }
            {props.showLikes &&
              <div style={{fontSize:14,lineHeight:1.3,marginTop:3}}>
                {style.likes} likes
              </div>
            }
            </React.Fragment>
          }
      </div>
    </div>
  )
}

SliderItem.defaultProps={
  responsive:false,
  showCounter:false,
  showPrice:true,
  showStyleName:true,
  showLikeButton:true
}
